import { render, staticRenderFns } from "./formulario-padres.vue?vue&type=template&id=20e7d271&scoped=true"
import script from "./formulario-padres.vue?vue&type=script&lang=js"
export * from "./formulario-padres.vue?vue&type=script&lang=js"
import style0 from "./formulario-padres.vue?vue&type=style&index=0&id=20e7d271&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e7d271",
  null
  
)

export default component.exports